<template>
  <div>
    <vs-prompt
      title="Add new Venue campaign"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the title of this venue campaign. It can be changed later."
                position="bottom"
              >
                <vs-input class="inputx w-full" v-model="name" />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
      venueId: null,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show(venueId) {
      this.name = "";
      this.prompt = true;
      this.venueId = venueId;
    },
    async accept() {
      this.$vs.loading();

      console.log("Create new venue campaign");
      var result = await this.$store.dispatch("venueCampaigns/create", {
        title: this.name,
        venueId: this.venueId,
      });
      this.$router.push({ name: "vp-venuecampaign", params: { id: result } }).catch(() => {});

      this.$vs.notify({
        color: "green",
        title: `Venue campaign created`,
        text: "Venue campaign created",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
